import { GET_SOCIAL_NETWORKS } from '../constants/ActionTypes';

export function getSocialNetworks() {
  return {
    type: GET_SOCIAL_NETWORKS,
    request: {
      op: 'get',
      path: '/@srisite',
    },
  };
}
